import { useSyncExternalStore as e } from "react";
//#region src/queries/admin/adminSessionFlag.ts
var t = "auth:hasAdminSession", n = /* @__PURE__ */ new Set(), r = () => {
	try {
		return typeof localStorage < "u" && localStorage.getItem(t) === "true";
	} catch {
		return !1;
	}
}, i = (e) => {
	try {
		typeof localStorage < "u" && localStorage.setItem(t, JSON.stringify(e));
	} catch {}
	n.forEach((e) => e());
}, a = (e) => {
	n.add(e);
	let r = (n) => {
		n.key === t && e();
	};
	return typeof window < "u" && window.addEventListener("storage", r), () => {
		n.delete(e), typeof window < "u" && window.removeEventListener("storage", r);
	};
}, o = () => e(a, r, () => !1);
//#endregion
export { i as setHasAdminSession, o as useHasAdminSession };
